export const getLastItem = (thePath: string) => {
  const clean = thePath.replace(/\/$/, '');
  return clean.substring(clean.lastIndexOf('/') + 1);
};
